// extracted by mini-css-extract-plugin
export default {"imageWrapper":"jF-z","hovered":"kF-z","hoverImage":"lF-z","mainImage":"mF-z","imageNoBackground":"nF-z","fullSizeImage":"oF-z"};